import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';

import { PRICE_LIST_PUBLISH_LEVEL_COLOR_MAP } from '@mitsubishi/pricing-list/data-access';

@Component({
  selector: 'apm-price-list-publish-level',
  imports: [CommonModule],
  templateUrl: './price-list-publish-level.component.html',
})
export class PriceListPublishLevelComponent {
  readonly level = input.required<string>();

  readonly publishLevelBackground = computed(() => {
    const level = this.level();
    return PRICE_LIST_PUBLISH_LEVEL_COLOR_MAP[level];
  });
}
